"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = require("./api");
var suplierCouponsApi = _interopRequireWildcard(require("@/api/suplierCouponsApi"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var _default = exports.default = {
  data: function data() {
    return {
      //弹窗
      tableData: {
        list: [],
        total: 0
      },
      pageFrom: {
        page: 1,
        limit: 15
      },
      loading: false,
      // 表格loading
      customers: [],
      customerType: [],
      miniProgramCustomer: false,
      //是否为小程序客户
      companies: [] // 所有单位列表
    };
  },
  methods: {
    getCustomerType: function () {
      var _getCustomerType = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _api.activeCustomersApi)({
                type: 3
              });
            case 1:
              res = _context.v;
              this.customerType = res;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getCustomerType() {
        return _getCustomerType.apply(this, arguments);
      }
      return getCustomerType;
    }(),
    //弹窗
    addGrant: function addGrant(row) {
      var params = {
        customerName: row.customerName,
        customerId: row.customerId,
        integralId: row.id
      };
      this.$refs.AddGrantVueRef.open(params);
    },
    batchGrant: function batchGrant(row) {
      var params = {
        customerName: row.customerName,
        customerId: row.customerId,
        integralId: row.id
      };
      this.$refs.BatchGrantVueRef.open(params);
    },
    recovery: function recovery(row) {
      var params = {
        customerName: row.customerName,
        customerId: row.customerId,
        integralId: row.id
      };
      this.$refs.RecoveryVueRef.open(params);
    },
    go: function go(row) {
      console.log(row, 'row');
      this.$router.push({
        path: '/business/clientManage/staffManage',
        query: {
          id: row.id,
          name: row.customerName
        }
      });
    },
    convertFudou: function convertFudou(row) {
      console.log(row, 'row');
      this.$router.push({
        path: '/business/integralManage/convertFudou',
        query: {
          customerInfo: row
        }
      });
    },
    hanldDelete: function () {
      var _hanldDelete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(row) {
        var _this = this;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.$confirm('确定删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                var params, res;
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      params = {
                        id: row.id
                      };
                      _context2.n = 1;
                      return (0, _api.deleteApi)(params);
                    case 1:
                      res = _context2.v;
                      _this.search();
                      _this.$message.success('操作成功');
                    case 2:
                      return _context2.a(2);
                  }
                }, _callee2);
              })));
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function hanldDelete(_x) {
        return _hanldDelete.apply(this, arguments);
      }
      return hanldDelete;
    }(),
    getCustomers: function () {
      var _getCustomers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return (0, _api.activeCustomersApi)();
            case 1:
              res = _context4.v;
              this.customers = res;
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function getCustomers() {
        return _getCustomers.apply(this, arguments);
      }
      return getCustomers;
    }(),
    getAllCompanies: function () {
      var _getAllCompanies = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return suplierCouponsApi.getAllCompany();
            case 1:
              res = _context5.v;
              this.companies = res;
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function getAllCompanies() {
        return _getAllCompanies.apply(this, arguments);
      }
      return getAllCompanies;
    }(),
    // 详情
    CapitalAllocation: function CapitalAllocation(row) {
      this.DetailVueRef.open(row.id);
    },
    // 列表
    getList: function getList() {
      var _this2 = this;
      this.loading = true;
      (0, _api.listsApi)(this.pageFrom).then(function (res) {
        _this2.tableData = res;
        _this2.loading = false;
      }).catch(function (err) {
        _this2.loading = false;
      });
    },
    search: function search() {
      this.pageFrom.page = 1;
      this.getList();
    }
  },
  created: function created() {
    this.miniProgramCustomer = suplierCouponsApi.getHomeType();
    this.getCustomers();
    this.getList();
    this.getCustomerType();
    this.getAllCompanies();
  }
};